var eligibility = {
    disputeOpened: 'Disputa Abierta',
    disputeOpenedPending: 'Deje que pasen 60 minutos para que el reclamo de disputa aparezca en el Centro de Disputas.',
    pleaseVisitDisputeCenter: 'Por favor visite <0>Gestionar Disputas</0> para más detalles.',
    disputeCanceled: 'Disputa Cancelada',
    cancelationPending: 'Cancelación Pendiente',
    disputeCompleted: 'Disputa Completada',
    disputeUnderReview: 'Disputa en Revisión',
    disputeDetails: 'Detalles de la Disputa',
    cancelThisDispute: 'Cancelar Esta Disputa',
    disputeThisTransaction: 'Disputar Esta Transacción',
    howToDispute: '¿Cómo puedo disputar esta transacción?',
    howToDisputeDescription: 'Por favor, comuníquese con nosotros por <0>chat en línea</0> o llamando al número que está en el dorso de su tarjeta o incluido en su estado de cuenta para que uno de nuestros representantes pueda ayudarlo a abrir este tipo de disputa. ',
    transactionEligibleError: 'Lo sentimos, pero actualmente estamos teniendo problemas para determinar el estatus de la disputa por esta transacción. Por favor, intente nuevamente más tarde.'
};
export default eligibility;
//# sourceMappingURL=eligibility.js.map